import React, { Component } from "react";
import { Button, FormGroup, FormControl, Spinner } from "react-bootstrap";
import ShowModalPopUp from '../ShowModalPopUp';
import '../../Resources/css/Login.css';
import { Link } from 'react-router-dom';
import iQumex from '../../Resources/images/iQumex-logo.jpg'
import logo from '../../Resources/images/logo.png'
import { connect } from 'react-redux';
import {ForgotAction, closeModalPopUp, ValidateOTP, ResetPassword, ResetAll} from './LoginActions';


class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userID: "",  
    };
  }
 
  validateForm() {
    if(this.state.userID && this.state.userID.length > 0)
    return true;
  }
  componentWillReceiveProps(nextProps){
      this.setState({onSubmit:nextProps.showOTP})
      this.setState({onVerify:nextProps.showReset})
    if(nextProps.resetDone === true){
      this.props.ResetAll()
      this.setState({userID: "", onSubmit:false, onVerify:false, password:"", Confirmpassword:"", otp:""})
    }
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }
 
  handleSubmit = event => {
   event.preventDefault();
   this.props.ForgotAction(this.state.userID)   
  }
  handleSubmitOTP = event => {
    event.preventDefault();
    let obj = {"employeeId": this.state.userID, "otpNumber": this.state.otp}
    this.props.ValidateOTP(obj)    
  }
  handleSubmitPassword = event => {
    let obj = {
      "confirmPassword": this.state.Confirmpassword,
      "employeeId": this.state.userID,
      "password": this.state.password
    }
    this.props.ResetPassword(obj) 
  }
  
  render() {
    const{ onSubmit, onVerify } = this.state;
    return (
      <div className="forgot_password"> 
      <div>
          <img src={iQumex} className='Project_iQumexLogo' alt={'logo1'} width='100%'/>
        <p className='logo'><img src={logo} className='Project_logo' alt={'logo'}/></p>
       </div>  
       {(this.props.showerror === true) ?
            <ShowModalPopUp message={this.props.errmessage} 
            falseShowModalPopUp={this.props.closeModalPopUp}/> : null}
       {this.props.isPending ? <p className='spinner'><Spinner animation="grow" role="status" size='lg'/>
        Loading...</p> : null} 
       <form onSubmit={this.handleSubmit} className={onVerify=== true ? 'disabled' :''}>
          <FormGroup controlId="userID" >       
              <FormControl
                autoFocus
                type="userID"
                value={this.state.userID}
                onChange={this.handleChange}
                placeholder = {"User ID"}
              />
            </FormGroup>  
            { onSubmit === true ?
            <FormGroup controlId="otp" >             
              <FormControl
               autoFocus
               type="OTP"
               value={this.state.otp}
               placeholder = {"OTP"}
               onChange={this.handleChange}
             />
              <h6 className='alignRight' style={{'color':'red', fontWeight:'bold'}}>**OTP send to registered e-mail id</h6>
           </FormGroup> 
           : null }
           {onSubmit === true ?
            <Button
              block
              disabled={!this.validateForm()}
              type="submit"
              className='buttonwidth'
              onClick={this.handleSubmitOTP}>
               Verify
            </Button> 
            :   
            <Button
              block
              disabled={!this.validateForm()}
              type="submit"
              className='buttonwidth'
              onClick={this.handleSubmit}>
               Submit
           </Button> }
        </form>
      <br/>
      {onVerify === true ?
      <div>
        <h6>Enter New Password</h6>
        <FormGroup controlId="password" >
        <FormControl
        autoFocus
        type="password"
        value={this.state.password}
        placeholder = {"Password"}
        onChange={this.handleChange}
        />
        </FormGroup> 
        <FormGroup controlId="Confirmpassword" >
        <FormControl
        autoFocus
        type="Confirmpassword"
        value={this.state.Confirmpassword}
        placeholder = {"Confirm Password"}
        onChange={this.handleChange}
        />
        </FormGroup> 
        <Button
          block
          disabled={!this.validateForm()}
          type="submit"
          className='buttonwidth'
          onClick={this.handleSubmitPassword}>
           Reset Password
        </Button>
      </div>



     : null}


      <Link to='/' className='buttonwidth alignRight'>Back to Login</Link>
      </div>
    );
  }
}

function mapStateToProps(state){
  return{
    loginAction: state.LoginReducer.loginAction,
    errmessage: state.LoginReducer.errmessage,
    showerror: state.LoginReducer.showerror,    
    isPending: state.LoginReducer.isPending,
    showOTP: state.LoginReducer.showOTP,
    showReset: state.LoginReducer.showReset,
    resetDone: state.LoginReducer.resetDone
  }  
}

const mapDispatchToProps = (dispatch) => ({
  ForgotAction: (a) => dispatch(ForgotAction(a)),
  ValidateOTP: (a) => dispatch(ValidateOTP(a)),
  ResetAll: (a) => dispatch(ResetAll(a)),  
  ResetPassword: (a) => dispatch(ResetPassword(a)),  
  closeModalPopUp: () => dispatch(closeModalPopUp())
})


export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
